import { Typography as MuiTypography } from '@mui/material';

function Typography(props){
  return(<MuiTypography color='text.primary' {...props}/>)
} export default Typography;